/* JOOST-SCROLLBAR-SYNC v4 - rAF poll */
(function(){
  function init(){
    var section = document.getElementById('shopify-section-product-recommendations') 
      || document.querySelector('[id^="shopify-section-"][id$="__product-recommendations"]')
      || document.querySelector('.shopify-section--product-recommendations');
    if(!section) return false;
    var inner = section.querySelector('.product-list__inner--scroller, .product-list__inner');
    var outer = section.querySelector('.scroller, product-list');
    var track = section.querySelector('.vl-related-products-scrollbar');
    var thumb = section.querySelector('.vl-related-products-scrollbar__thumb');
    if(!track || !thumb) return false;
    var candidates = [outer, inner].filter(Boolean);
    if(!candidates.length) return false;
    if(track.__joostBound) return true;
    track.__joostBound = true;

    function getState(){
      // Pick element with largest measurable scroll
      var best = null;
      for (var i=0;i<candidates.length;i++){
        var el = candidates[i];
        var sw = el.scrollWidth, cw = el.clientWidth;
        if(sw > cw + 1){
          if(!best || (sw - cw) > (best.sw - best.cw)) best = { el: el, sw: sw, cw: cw, sl: el.scrollLeft };
        }
      }
      // If no scrollLeft variation, try transform on inner
      if(!best && inner){
        var ics = getComputedStyle(inner);
        var t = ics.transform;
        if(t && t!=='none' && inner.scrollWidth > inner.clientWidth){
          var m = t.match(/matrix\(([^)]+)\)/);
          var tx = 0;
          if(m){ var parts = m[1].split(','); tx = -parseFloat(parts[4]||0); }
          return { sw: inner.scrollWidth, cw: inner.clientWidth, sl: tx };
        }
      }
      return best;
    }

    var lastTx = -1;
    function update(){
      var st = getState();
      if(!st){ track.style.display='none'; return; }
      if(st.sw <= st.cw + 1){ track.style.display='none'; return; }
      track.style.display='block';
      var trackW = track.clientWidth;
      var thumbW = Math.max(40, (st.cw/st.sw)*trackW);
      var maxScroll = st.sw - st.cw;
      var pct = maxScroll > 0 ? Math.max(0, Math.min(1, st.sl / maxScroll)) : 0;
      var tx = pct * (trackW - thumbW);
      if(Math.abs(tx - lastTx) < 0.5) return;
      lastTx = tx;
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translate3d(' + tx + 'px,0,0)';
    }

    // rAF polling loop — brute force, catches any position change
    function loop(){
      update();
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    // Also: native scroll events
    candidates.forEach(function(el){ el.addEventListener('scroll', update, {passive:true}); });
    window.addEventListener('resize', update);

    return true;
  }
  function tryInit(){
    if(init()) return;
    var tries=0;
    var iv=setInterval(function(){ tries++; if(init()||tries>40) clearInterval(iv); }, 200);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', tryInit); } else { tryInit(); }
  document.addEventListener('shopify:section:load', tryInit);
})();
